export default "__VITE_ASSET__810f60d9__"